import { render, staticRenderFns } from "./AvailableTable.vue?vue&type=template&id=72daf651&scoped=true&"
import script from "./AvailableTable.vue?vue&type=script&lang=js&"
export * from "./AvailableTable.vue?vue&type=script&lang=js&"
import style0 from "./AvailableTable.vue?vue&type=style&index=0&id=72daf651&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72daf651",
  null
  
)

export default component.exports